import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonWriterClass;
function StringJsonWriter() {
  if (StringJsonWriterClass === VOID) {
    class $ {
      constructor() {
        this.c2o_1 = StringBuilder().vb(128);
      }
      j2t(value) {
        this.c2o_1.bh(value);
      }
      d2t(char) {
        this.c2o_1.o1(char);
      }
      f2t(text) {
        this.c2o_1.m1(text);
      }
      p2t(text) {
        printQuoted(this.c2o_1, text);
      }
      d2o() {
        this.c2o_1.eh();
      }
      toString() {
        return this.c2o_1.toString();
      }
    }
    initMetadataForClass($, 'StringJsonWriter', StringJsonWriter);
    StringJsonWriterClass = $;
  }
  return StringJsonWriterClass;
}
//region block: exports
export {
  StringJsonWriter as StringJsonWriter17tm33td3svia,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
